import React, {useState, useEffect, useRef, useMemo} from "react";
import debounce from '@utils/debounce';


const YotpoReviewCarousel = props => {

    const {
        mode,
        type,
        count,
        showBottomLine,
        showNavigation,
        autoPlay,
        autoPlaySpeed,
        headerEnabled,
        headerColor,
        headerSize,
        headerText,
        headerAlignCenter
    } = props;
    //useYotpoRefresh();
    const debounceTime = 200;

    const notSSR = typeof window !== 'undefined';

    const debouncedRefresh = useMemo(() => {
        const refreshWidgets = notSSR && window.yotpo && window.yotpo.refreshWidgets
            ? window.yotpo.refreshWidgets.bind(window.yotpo)
            : () => {
            };

        return debounce(refreshWidgets, debounceTime);
    }, [debounceTime]);

    let attr = {};

    if (headerEnabled && headerEnabled === "1") {
        attr = {
            "data-header-customisation-enabled": "1",
            "data-header-customisation-color": headerColor || "#56575f",
            "data-header-customisation-font-size": headerSize || "18",
            "data-header-customisation-text": headerText || "Reviews",
            "data-header-customisation-alignment": headerAlignCenter && headerAlignCenter === "1" ? "center" : "left"
        }
    }
    let showBottomLineAttr = {};
    if (showBottomLine && showBottomLine === "1") {
        showBottomLineAttr = {"data-show-bottomline": "1"};
    }
    let navAttr = {};
    if (showBottomLine && showBottomLine === "1") {
        navAttr = {"data-show-navigation": "1"};
    }
    let playAttr = {};
    if (autoPlay && autoPlay === "1") {
        playAttr = {
            "data-autoplay-enabled": "1",
            "data-autoplay-speed": autoPlaySpeed || "3000"
        };
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.yotpo) {
            debouncedRefresh();
        }
    }, [debouncedRefresh]);

    return (
        <React.Fragment>
            <div className={"review-container"}>
                <div className="yotpo yotpo-reviews-carousel"
                     {...attr}
                     data-background-color="transparent"
                     data-mode={mode || "top_rated"}
                     data-type={type || "both"}
                     data-count={count || "3"}
                     {...showBottomLineAttr}
                     {...navAttr}
                     {...playAttr}
                >&nbsp;</div>
            </div>
        </React.Fragment>
    );
};
export default YotpoReviewCarousel;